export const UserManagement_TABLE_TITLE = 'Orders Listing';
export const UserManagement_TABLE_TITLE_RIA = 'Trade Allocations';
export const UserManagement_TABLE_INFO_URL = '';
